import React, { useState } from "react";
import { Button, Grid, Toolbar } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import {useNavigate, useLocation, useParams} from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

const Header = ({getFilterData}) => {
  const theme = useTheme();
  const classes = useStyles();

  const matchesMD = useMediaQuery(theme.breakpoints.up("md"));
  const matchesSM = useMediaQuery(theme.breakpoints.up("sm"));
  const matchesLG = useMediaQuery(theme.breakpoints.up("lg"));
  const matchesXL = useMediaQuery(theme.breakpoints.up("xl"));
  const navigate = useNavigate(); 
    const locationInfo = useLocation();
     const searchParams = new URLSearchParams(locationInfo.search);
     const locId = useParams("id");
  const handleModalOpen =() =>{
    navigate(`/resturant-wineries/details/new?locId=${locId.id}&&locname=${searchParams.get("name")}`)
  }
  return (
    <Toolbar style={{ backgroundColor: "#f8f9fa", padding: "1rem" }}>
      <Grid container spacing={3} alignItems="center">
        <Grid item>
        <Button
                variant="outlined"
                color="primary"
                sx={{
                    position: 'absolute',
                    top: 16,
                    left: 16,
                    '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)', // Adjust to a darker shade
                    },
                }}
                onClick={() => navigate('/resturant-locations')}
                startIcon={<ArrowBackIcon />}
            >
                Back
            </Button>
        </Grid>
        <Grid
          item
          xs
          style={{
            textAlign: "center",
            width: matchesXL
              ? "65em"
              : matchesLG
              ? "50em"
              : matchesMD
              ? "35em"
              : matchesSM
              ? "28em"
              : "23em",
          }}
        >
          <span
            style={{
              color: "#313137",
              fontWeight: 700,
              fontSize: 32,
              textTransform: "uppercase",
            }}
          >
            Restaurants & Wineries
          </span>
        </Grid>
        <Grid item style={{ textAlign: "end", display: "flex", alignItems: "center", gap: "1rem" }}>
          <Button
            variant="contained"
            onClick={handleModalOpen}
            endIcon={<AddOutlinedIcon style={{ fontSize: 24 }} />}
            style={{
              color: "#fff",
              background: "#C84B96",
              borderRadius: 38,
              fontWeight: 600,
              textTransform: "capitalize",
              fontSize: 15,
              height: 50,
              padding: "0 1.5rem",
            }}
          >
            Add Restaurant
          </Button>
        </Grid>
      </Grid>
    </Toolbar>
  );
};

export default Header;

const useStyles = makeStyles(() => {
  return {
    headerTitle: {
      color: "#313137",
      fontSize: 36,
      fontWeight: 700,
      textAlign: "center",
    },
    customWidth: {
      "& div": {
        width: "305px",
        borderRadius: 20,
        padding: "0px 7px",
      },
    },
    sortTitle: {
      fontWeight: 600,
      fontSize: 16,
      // fontFamily: "Poppins",
      color: "#000",
    },
    sortItems: {
      fontWeight: 500,
      fontSize: 16,
      // fontFamily: "Poppins",
      color: "#000",
    },
    dateTextfield: {
      width: 253,
    },
  };
});
